import { useRef, useState } from 'react';
import { mutate } from 'swr';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import { addToCartHandler } from '../../../Utils/productAction';
import { SnackBar } from '../../Product/PdpHeader/styled';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import { clickedAddToCart } from '../instrumentation';
import { AddToCartButtonFilled } from './styled';

export default function AddSizeToCart(props) {
  const {
    productId,
    setAddedToCart,
    smallButton,
    disabled,
    eventsData,
    cardName,
  } = props;

  const { data } = useGetCartData();
  const [showToast, setShowToast] = useState(false);
  const [showCssLoader, setShowCssLoader] = useState(false);
  const addToCart = useRef();
  const ctaClickHandler = async (e) => {
    if (!disabled) {
      setShowCssLoader(true);
      e.stopPropagation();
      if (data) {
        await mutate('/api/getNewCartAmountOfUserWeb', null, false);
      }
      clickedAddToCart(productId, cardName, eventsData);
      const success = await addToCartHandler(productId);
      if (success) {
        setShowCssLoader(false);
      }
      setAddedToCart((props) => !props);
    } else {
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 2000);
    }
  };
  return (
    <>
      <SnackBar className={showToast ? 'show' : ''}>
        Please select a size to add!
      </SnackBar>
      <AddToCartButtonFilled
        verm={showCssLoader}
        className="add_btn_filled"
        onClick={ctaClickHandler}
        smallButton={smallButton}
        disabled={disabled}
        ref={addToCart}
        id="addSizeToCart"
      >
        {showCssLoader ? (
          <CssLoader mdpage={true} className="load-complete" />
        ) : (
          'ADD TO CART'
        )}
      </AddToCartButtonFilled>
    </>
  );
}
